import { Component, OnInit } from '@angular/core';
import { Alert } from 'src/app/interfaces/alert';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import {
  AuthManagerService,
  UserAuthenticationType,
} from 'src/app/services/auth-manager/auth-manager.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  loading = false;
  alert: Alert = null;
  errorStrings = ErrorStrings;
  showSetPassView = false;
  authWithChipNumber: boolean = false;
  useRebrandedLayout: boolean;

  model: any = {
    identifier: '',
  };

  constructor(
    public authManager: AuthManagerService,
    private route: ActivatedRoute,
    private featureFlagService: FeatureFlagsService
  ) {
     this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  public onAuthWithChipNumberChanged(event: MatSlideToggleChange) {
    this.authWithChipNumber = event.checked;
    this.model.identifier = '';
  }

  forgotPassword() {
    this.closeAlert();
    this.loading = true;
    const authenticationType = this.authWithChipNumber
      ? UserAuthenticationType.ChipNumber
      : this.model.identifier.includes('@')
      ? UserAuthenticationType.Email
      : UserAuthenticationType.PhoneNumber;
    this.authManager
      .forgotPassword({
        identifier: this.model.identifier,
        authenticationType: authenticationType,
      })
      .subscribe(
        (response) => {
          // Only display the full email address if the user provided an email (and not chip or phone number)
          const emailToDisplay =
            authenticationType === UserAuthenticationType.Email
              ? response.email
              : `${response.email[0]}***${response.email.slice(
                  response.email.indexOf('@') - 1,
                  response.email.length
                )}`;
          this.alert = {
            type: 'success',
            message: `If an account exists for ${emailToDisplay}, an email with further instructions has been sent. Please check your inbox.`,
          };
        },
        (err) => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            if (err.error) {
              this.alert = {
                type: 'danger',
                message: err.error.error_message,
              };
            } else {
              this.alert = {
                type: 'danger',
                message: 'An error has occurred. Please try again later.',
              };
            }
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.',
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  ngOnInit(): void {
    // Prefill email address if "email" is passed as query param
    if (this.route.snapshot.queryParams.email) {
      this.model.identifier = this.route.snapshot.queryParams.email;
      // Display a set password message
      if (
        this.route.snapshot.queryParams.type &&
        this.route.snapshot.queryParams.type === 'passnotset'
      ) {
        this.showSetPassView = true;
      }
    }
  }

  closeAlert() {
    this.alert = null;
  }
}
